import React, { useState, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { createUseStyles } from "react-jss";
import { useHistory } from 'react-router';
import { reaction } from '../services/productService';
import { Product } from "../types";
import AddToCartModal from './AddToCartModal';
import BackgroundImage from './BackgroundImage';
import Text from './Text';

export interface NavBarMostProductProps {
    product: Product;
}
const NavBarMostProduct: React.FC<NavBarMostProductProps> = ({ product }) => {
    const classes = useStyles();
    const history = useHistory();
    const hasDiscount = product.originalPrice !== product.discountedPrice && product.discountedPrice != 0;
    const { currencyCode } = product.currency;
    const [showModal, setShowModal] = useState(false);

    const handleToggleModal = useCallback(() => {
        (async () => {

            setShowModal(!showModal);
            if (!showModal) {
                await reaction({ "type": "Click", "product_id": product.id })
            }
        })();

    }, [showModal]);


    const goToLink = useCallback((link, isAffiliate?, e?) => {
        (async () => {
            // alert("SSS")
            if (e) {
                e.preventDefault();
            }
            try {
                if (isAffiliate) {
                    window.open(link, "_blank") //to open new page        
                    var x = await reaction({ "type": "Click", "product_id": product.id })
                } else {
                    history.push(link)
                    // if (trackName) {
                    //     track(trackName)
                    // }
                }
            } catch (error) {

            }
        })();

    }, []);

    return (
        <>

            <AddToCartModal
                product={product}
                onClose={handleToggleModal}
                onHide={handleToggleModal}

                show={showModal}
            />
            <div className={classes.mainProduct}>
                <a href={product.uniqueName} onClick={(e) => goToLink(product.uniqueName, false, e)} className={classes.mainProductImgDiv}>
                    <div className={classes.mainProductImgDiv}>
                        <BackgroundImage className={classes.mainProductImg} src={product.photo} height="30px"></BackgroundImage>
                    </div>
                </a>
                <div>
                    {
                        product.is_verified ?
                            product.affiliate == "EXTERNAL" || product.affiliate == "INTERNAL" ?
                                <Button className={classes.mainProductButton} onClick={() => goToLink(product.affiliate == "EXTERNAL" ? product.affiliate_link : product.original_url, true)}>
                                    <Text color='white' as="span" bold capitalized>
                                         Buy On {product.business.name}
                                     </Text>
                                 </Button> :
                                 <Button className={classes.mainProductButton} onClick={handleToggleModal}>
                                     <Text color='white' as="span" bold capitalized>
                                         Add To Cart
                                     </Text>
                                 </Button> : null
                    }
                </div>
                <a href={product.uniqueName} onClick={(e) => goToLink(product.uniqueName, false, e)}>
                    <Text as="p" className={classes.mainProductName} bold color="black">{product.name}</Text>

                </a>
                <div className={classes.mainProductPriceDiv}>
                    <Text className={classes.navProductPrice} bold>
                        {hasDiscount ? product.discountedPrice : product.originalPrice}{' '}
                        {product.originalPrice ? currencyCode : null}

                    </Text>
                    {hasDiscount ?
                        <Text className={classes.navProductPriceDiscount}>
                            {product.originalPrice} {currencyCode}
                        </Text>
                        : null}
                </div>
            </div>
        </>
    )
}

const useStyles = createUseStyles({
    mainProduct: {
        width: "200px",
        margin: "10px auto",
    },
    mainProductImgDiv: {
        width: "200px",
        height: "200px"
    },
    mainProductImg: {
        backgroundPosition: "center",
        backgroundSize: "cover",
        width: "100%",
        height: "100%"
    },
    mainProductButton: {
        top: '4px',
        right: '0px',
        flex: 1,
        fontSize: '14px',
        backgroundColor: '#522583',
        padding: '2px 25px',
        border: "none",
        borderRadius: '20px',
        margin: "7px auto !important",
        display: 'block',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: '#3d1c77',
        },
    },
    mainProductName: {
        fontSize: "15px"
    },
    mainProductPriceDiv: {
        display: 'flex',
        alignItems: "center",
    },
    navProductPrice: {
        margin: "0px 5px"
    },
    navProductPriceDiscount: {
        fontSize: "0.9rem",
        textDecoration: "line-through",
        color: "#522583 !important"
    }

});

export default NavBarMostProduct;
